import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setErr(""); setLoading(true);
    const r = await login(email, password);
    setLoading(false);
    if (r.ok) {
      toast.success("Welcome back");
      navigate(loc.state?.from || "/portal", { replace: true });
    } else setErr(r.error);
  };

  return (
    <div className="section-y" data-testid="login-page">
      <div className="container-x max-w-md">
        <div className="overline">Member portal</div>
        <h1 className="font-display text-4xl text-sage-800 mt-3">Welcome back.</h1>
        <form onSubmit={submit} className="mt-8 space-y-4 rounded-3xl bg-white border border-sand-200/60 p-7">
          <div><Label>Email</Label><Input type="email" value={email} onChange={(e)=>setEmail(e.target.value)} data-testid="login-email" required /></div>
          <div><Label>Password</Label><Input type="password" value={password} onChange={(e)=>setPassword(e.target.value)} data-testid="login-password" required /></div>
          {err && <div className="text-sm text-destructive" data-testid="login-error">{err}</div>}
          <Button type="submit" disabled={loading} className="btn-pill h-11 w-full bg-sage-700 hover:bg-sage-800 text-white" data-testid="login-submit">{loading?"Signing in…":"Sign in"}</Button>
          <div className="text-sm text-sage-800/70 text-center">New here? <Link to="/register" className="text-sage-700 underline" data-testid="link-register">Create account</Link></div>
        </form>
      </div>
    </div>
  );
}

export function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setErr(""); setLoading(true);
    const r = await register(form);
    setLoading(false);
    if (r.ok) { toast.success("Welcome to Restore"); navigate("/portal"); } else setErr(r.error);
  };
  return (
    <div className="section-y" data-testid="register-page">
      <div className="container-x max-w-md">
        <div className="overline">Create your Restore account</div>
        <h1 className="font-display text-4xl text-sage-800 mt-3">Join Restore.</h1>
        <form onSubmit={submit} className="mt-8 space-y-4 rounded-3xl bg-white border border-sand-200/60 p-7">
          <div><Label>Name</Label><Input value={form.name} onChange={(e)=>setForm({...form,name:e.target.value})} data-testid="reg-name" required /></div>
          <div><Label>Email</Label><Input type="email" value={form.email} onChange={(e)=>setForm({...form,email:e.target.value})} data-testid="reg-email" required /></div>
          <div><Label>Phone (optional)</Label><Input value={form.phone} onChange={(e)=>setForm({...form,phone:e.target.value})} data-testid="reg-phone" /></div>
          <div><Label>Password</Label><Input type="password" value={form.password} onChange={(e)=>setForm({...form,password:e.target.value})} data-testid="reg-password" required minLength={6} /></div>
          {err && <div className="text-sm text-destructive" data-testid="reg-error">{err}</div>}
          <Button type="submit" disabled={loading} className="btn-pill h-11 w-full bg-sage-700 hover:bg-sage-800 text-white" data-testid="reg-submit">{loading?"Creating…":"Create account"}</Button>
          <div className="text-sm text-sage-800/70 text-center">Already a member? <Link to="/login" className="text-sage-700 underline" data-testid="link-login">Sign in</Link></div>
        </form>
      </div>
    </div>
  );
}
